import { throttle } from "./throttle";

/*
 * Registered DOM nodes where the keys are the actual nodes
 * and the values the callback functions and flags.
 */
const registry = new Map();

const cascade = throttle(150, () => {
	registry.forEach(({ handler, paused }) => {
		if (paused) {
			return;
		}
		handler();
	});
});

window.addEventListener("resize", cascade);

export function watch(domNode, handler) {
	registry.set(domNode, { handler, paused: false });
}

export function unwatch(domNode) {
	registry.delete(domNode);
}

export function pause(domNode) {
	registry.get(domNode).paused = true;
}

export function resume(domNode) {
	registry.get(domNode).paused = false;
}
